module.exports = __webpack_public_path__ + "static/media/jobfamily_active.3c9a9d6c.svg";